import { createApi } from '@reduxjs/toolkit/query/react';
import {
  CallNextAPIResponse,
  GetCalledAPIResponse,
  PendingCounterApiResponse,
  TotemSectorMutationArgs,
} from '../models';
import { API_ATTEND_TRACK_URL } from '@/utils';
import { createBaseQueryWithReauth } from '@/services';

const totemSectorService = createApi({
  reducerPath: 'totemSectorService',
  baseQuery: createBaseQueryWithReauth(`${API_ATTEND_TRACK_URL}/totem-sector`),
  tagTypes: ['PendingSectorsCount'],
  endpoints: (builder) => ({
    pendingSectorsCount: builder.query<PendingCounterApiResponse[], void>({
      query: () => '/pending-counter',
      providesTags: ['PendingSectorsCount'],
    }),
    callNext: builder.mutation<CallNextAPIResponse, string>({
      query: (sectorId) => ({
        url: `/${sectorId}/call-next`,
        method: 'POST',
      }),
    }),
    call: builder.mutation<CallNextAPIResponse, TotemSectorMutationArgs>({
      query: (body) => ({
        url: '/call',
        method: 'POST',
        body,
      }),
    }),
    getCalledTicket: builder.query<GetCalledAPIResponse, string>({
      query: (trackId) => `/${trackId}`,
    }),
    attend: builder.mutation<unknown, TotemSectorMutationArgs>({
      query: (body) => ({
        url: '/attending',
        method: 'POST',
        body,
      }),
    }),
    finalizeWithSuccess: builder.mutation<unknown, TotemSectorMutationArgs>({
      query: (body) => ({
        url: '/finalized',
        method: 'POST',
        body,
      }),
    }),
    finalizeWithIssues: builder.mutation<unknown, TotemSectorMutationArgs>({
      query: (body) => ({
        url: '/finalized-with-issue',
        method: 'POST',
        body,
      }),
    }),
    markAsWaiting: builder.mutation<unknown, TotemSectorMutationArgs>({
      query: (body) => ({
        url: '/status/waiting',
        method: 'PATCH',
        body: {
          sectorsId: body.sectorId,
          trackNumber: body.trackNumber,
        },
      }),
    }),
  }),
});

export default totemSectorService;

export const {
  usePendingSectorsCountQuery,
  useCallNextMutation,
  useCallMutation,
  useGetCalledTicketQuery,
  useAttendMutation,
  useFinalizeWithSuccessMutation,
  useFinalizeWithIssuesMutation,
  useMarkAsWaitingMutation,
} = totemSectorService;
